export enum SessionJoinState {
  NothingYet = "nothing_yet",
  Early = "early",
  JoinNow = "join_now",
  Missed = "missed",
  Ended = "ended",
  ReJoin = "rejoin",
}
